import { createContext } from "react";

const InvoiceContext = createContext({
  invoiceCount: 0,
  setInvoiceCount: () => {},
});

export default InvoiceContext;
